export default "__VITE_ASSET__BUBp_MYs__"